export enum ProductFieldDisplayType {
    CHECKBOX = 'check_box',
    RADIO_BUTTON = 'radio_button',
    IMAGE = 'image'
}
